import { render, staticRenderFns } from "./ClassNewDialogButton.vue?vue&type=template&id=50e9cb6c"
import script from "./ClassNewDialogButton.vue?vue&type=script&lang=js"
export * from "./ClassNewDialogButton.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports